import api from './request';

export const increase = (params) => {
    return api
        .request("menuitem/increase")
        .withParams(params)
        .post();
};

export const decrease = (params) => {
    return api
        .request("menuitem/decrease")
        .withParams(params)
        .post();
};

export const create = (params) => {
    return api
        .request("cart/create")
        .withParams(params)
        .post();
};

export const remove = (params) => {
    return api
        .request("cart/remove")
        .withParams(params)
        .post();
};
